(function () {
  'use strict';

  function initFeaturedCollection(section) {
    if (!section) return;

    const carousel = section.querySelector('[data-bd-feat-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-bd-feat-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-bd-feat-slide]'));

    const prevButton = carousel.querySelector('[data-bd-feat-prev]');
    const nextButton = carousel.querySelector('[data-bd-feat-next]');
    const dotsContainer = carousel.querySelector('[data-bd-feat-dots]');

    if (!track || slides.length === 0) return;

    const autoplayEnabled =
      carousel.dataset.autoplay === 'true';

    const autoplaySpeed =
      parseInt(carousel.dataset.autoplaySpeed, 10) || 5;

    let currentIndex = 0;
    let autoplayTimer = null;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    let isTouching = false;


    /* =====================================================
       GET CURRENT VISIBLE SLIDES
       ===================================================== */

    function getSlidesPerView() {

      if (window.innerWidth <= 749) {
        return 1.2;
      }

      return parseFloat(
        carousel.dataset.slidesDesktop
      ) || 4;
    }


    /* =====================================================
       MAX INDEX
       ===================================================== */

    function getMaxIndex() {

      const slidesPerView = getSlidesPerView();

      if (window.innerWidth <= 749) {
        return Math.max(
          0,
          slides.length - 1
        );
      }

      return Math.max(
        0,
        Math.ceil(slides.length - slidesPerView)
      );
    }


    /* =====================================================
       UPDATE CAROUSEL
       ===================================================== */

    function updateCarousel(animate = true) {

      const slidesPerView = getSlidesPerView();

      const maxIndex = getMaxIndex();

      currentIndex = Math.min(
        Math.max(currentIndex, 0),
        maxIndex
      );


      const firstSlide = slides[0];

      if (!firstSlide) return;


      const slideWidth =
        firstSlide.getBoundingClientRect().width;


      const trackStyle =
        window.getComputedStyle(track);

      const gap =
        parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;


      const offset =
        currentIndex * (slideWidth + gap);


      track.style.transition =
        animate
          ? 'transform 0.45s ease'
          : 'none';


      track.style.transform =
        'translate3d(-' + offset + 'px, 0, 0)';


      updateButtons();

      updateDots();
    }


    /* =====================================================
       BUTTONS
       ===================================================== */

    function updateButtons() {

      if (!prevButton && !nextButton) return;

      const maxIndex = getMaxIndex();


      if (prevButton) {
        prevButton.disabled =
          currentIndex <= 0;
      }


      if (nextButton) {
        nextButton.disabled =
          currentIndex >= maxIndex;
      }
    }


    /* =====================================================
       DOTS
       ===================================================== */

    function createDots() {

      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      const maxIndex = getMaxIndex();

      if (maxIndex <= 0) {
        return;
      }


      for (let i = 0; i <= maxIndex; i++) {

        const dot =
          document.createElement('button');

        dot.type = 'button';

        dot.className = 'bd-dot';

        dot.setAttribute(
          'aria-label',
          'Go to slide ' + (i + 1)
        );


        dot.addEventListener(
          'click',
          function () {

            currentIndex = i;

            updateCarousel();

            restartAutoplay();
          }
        );


        dotsContainer.appendChild(dot);
      }
    }


    function updateDots() {

      if (!dotsContainer) return;

      const dots =
        dotsContainer.querySelectorAll('.bd-dot');


      dots.forEach(function (dot, index) {

        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );

      });
    }


    /* =====================================================
       NEXT
       ===================================================== */

    function nextSlide() {

      const maxIndex = getMaxIndex();

      if (maxIndex <= 0) return;


      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }


      updateCarousel();

      restartAutoplay();
    }


    /* =====================================================
       PREVIOUS
       ===================================================== */

    function previousSlide() {

      const maxIndex = getMaxIndex();

      if (maxIndex <= 0) return;


      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex--;
      }


      updateCarousel();

      restartAutoplay();
    }


    /* =====================================================
       DESKTOP BUTTON EVENTS
       ===================================================== */

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        previousSlide
      );
    }


    if (nextButton) {
      nextButton.addEventListener(
        'click',
        nextSlide
      );
    }


    /* =====================================================
       TOUCH — START
       ===================================================== */

    carousel.addEventListener(
      'touchstart',
      function (event) {

        if (window.innerWidth > 749) {
          return;
        }

        if (!event.touches || !event.touches.length) {
          return;
        }


        isTouching = true;

        startX =
          event.touches[0].clientX;

        currentX = startX;

        isDragging = false;


        stopAutoplay();

      },
      { passive: true }
    );


    /* =====================================================
       TOUCH — MOVE
       ===================================================== */

    carousel.addEventListener(
      'touchmove',
      function (event) {

        if (!isTouching) return;

        if (window.innerWidth > 749) {
          return;
        }


        currentX =
          event.touches[0].clientX;


        const difference =
          currentX - startX;


        if (Math.abs(difference) > 8) {
          isDragging = true;
        }

      },
      { passive: true }
    );


    /* =====================================================
       TOUCH — END
       ===================================================== */

    carousel.addEventListener(
      'touchend',
      function () {

        if (!isTouching) return;

        isTouching = false;


        const difference =
          currentX - startX;


        const swipeThreshold = 45;


        if (
          isDragging &&
          Math.abs(difference) >= swipeThreshold
        ) {

          if (difference < 0) {
            nextSlide();
          } else {
            previousSlide();
          }

        } else {

          restartAutoplay();

        }

        isDragging = false;

      },
      { passive: true }
    );


    /* =====================================================
       AUTOPLAY
       ===================================================== */

    function startAutoplay() {

      stopAutoplay();

      if (!autoplayEnabled) {
        return;
      }


      /*
        On mobile, autoplay is also enabled.
        On desktop, same behaviour.
      */

      autoplayTimer =
        setInterval(
          function () {

            if (!isTouching) {
              nextSlide();
            }

          },
          autoplaySpeed * 1000
        );
    }


    function stopAutoplay() {

      if (autoplayTimer) {

        clearInterval(
          autoplayTimer
        );

        autoplayTimer = null;
      }
    }


    function restartAutoplay() {

      stopAutoplay();

      startAutoplay();
    }


    /* =====================================================
       PAUSE WHEN HOVERING — DESKTOP
       ===================================================== */

    carousel.addEventListener(
      'mouseenter',
      function () {

        if (window.innerWidth > 749) {
          stopAutoplay();
        }

      }
    );


    carousel.addEventListener(
      'mouseleave',
      function () {

        if (window.innerWidth > 749) {
          startAutoplay();
        }

      }
    );


    /* =====================================================
       RESIZE
       ===================================================== */

    let resizeTimer;

    window.addEventListener(
      'resize',
      function () {

        clearTimeout(resizeTimer);

        resizeTimer =
          setTimeout(
            function () {

              createDots();

              updateCarousel(false);

            },
            150
          );

      }
    );


    /* =====================================================
       INITIALIZE
       ===================================================== */

    createDots();

    updateCarousel(false);

    startAutoplay();


    /* =====================================================
       CLEANUP
       ===================================================== */

    return function cleanup() {
      stopAutoplay();
    };
  }


  /* =======================================================
     INITIAL PAGE LOAD
     ======================================================= */

  function initializeAll() {

    document
      .querySelectorAll(
        '[data-bd-feat-carousel]'
      )
      .forEach(function (carousel) {

        const section =
          carousel.closest('.bd-feat-section');

        if (section) {
          initFeaturedCollection(section);
        }

      });
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target;

      if (
        section &&
        section.classList.contains(
          'bd-feat-section'
        )
      ) {

        initFeaturedCollection(
          section
        );

      }

    }
  );

})();